export const buildData = (arg) => {
  const {
    variantId,
    parameters,
    projectNumber,
    projectReference,
  } = arg;
  if (!parameters || !variantId) return null;

  let form = new FormData();
  form.append('variant_id', variantId);
  form.append('parameters[project_number]', projectNumber);
  form.append('parameters[project_reference]', projectReference);
  form.append('quantity', 1);
  Object.keys(parameters).forEach((key) => {
    if (key === 'filename') return;
    form.append(`parameters[${key}]`, parameters[key]);
  });
  // Object.keys(stencilsParameters).forEach((key) => {
  //   form.append(`parameters[${key}]`, stencilsParameters[key]);
  // });
  // form.append('parameters[part_number]', `${partNumber}-${parameters.stencil_side}`);
  // form.append('parameters[revision]', revision);

  // append file to each stencil
  const inputFile = $('#gerber-file')
  const file = inputFile ? inputFile.prop('files')[0] : null
  if (file) form.append('parameters[filename]', file);

  return form;
}

export const buildForms = (args) => {
  if(!args) return [];

  const { stencils, stencilsParameters, project_number, project_reference, partNumber, revision } = args;
  if(!stencils || !stencils.length) return [];

  return stencils.map((stencil) => {
    const parameters = {
      ...stencil.parameters,
      ...stencilsParameters,
      part_number: `${partNumber}-${stencil.parameters.stencil_side}`,
      revision,
    };

    return buildData({
      variantId: stencil.variant.id,
      parameters,
      projectNumber: project_number,
      projectReference: project_reference,
    });
  })
}